import { differenceInMilliseconds } from "date-fns";
import { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";

import { invalidateSession } from "../components/ui library/helpers/functions";
import AuthContext from "../context/AuthProvider";
import axios from "../components/api/axios";
import DataContext from "../context/DataContext";

const useForceLogout = () => {
  const { setAuth } = useContext(AuthContext);
  const {
    accessToken,
    getAccessToken,
    setCaseManagerPk,
    setSelectedProvider,
    setSelectedClient,
    setUserType,
    setDashCompLimit,
    setErrorMessage,
  } = useContext(DataContext);
  const [forceLogout, setForceLogout] = useState(false);

  async function handleLogout() {
    setAuth(null);
    getAccessToken("");
    setCaseManagerPk("");
    setSelectedProvider("");
    setSelectedClient("");
    setUserType("");
    setDashCompLimit(5);
    setErrorMessage("Your login has expired, please log in again!");
    await invalidateSession();
    setForceLogout(false);
  }

  async function handleContinue() {
    await axios.get("/api/users/me/", {
      headers: {
        Authorization: `Token ${accessToken}`,
      },
    })
    .then(() => setForceLogout(false));
  }
  
  useEffect(() => {
    const interval = setInterval(() => {
      const exp = Cookies.get("token_exp");
      if (exp) {
        console.log('Token Check');
        const remaining = differenceInMilliseconds(new Date(exp), new Date());
        // 120000 miliseconds equals to 2 minutes
        if (remaining <= 120000 && remaining > 0) {
          console.log('Token Check almost TTL');
          setForceLogout(true);
        }
      }
    }, 10000); // Check every 10s
  
    return () => clearInterval(interval);
  }, []);

  return {
    forceLogout,
    handleLogout,
    handleContinue
  };
};

export default useForceLogout;
